import React from "react";

export const SecurePayment = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="61"
      viewBox="0 0 60 61"
      fill="none"
      {...props}
    >
      <path
        d="M27.5117 5.61035L45.7567 11.3104C46.2656 11.4692 46.7103 11.7866 47.0261 12.2161C47.3418 12.6456 47.5119 13.1648 47.5117 13.6979V18.1104H52.5117C53.1748 18.1104 53.8106 18.3737 54.2795 18.8426C54.7483 19.3114 55.0117 19.9473 55.0117 20.6104V40.6104C55.0117 41.2734 54.7483 41.9093 54.2795 42.3781C53.8106 42.847 53.1748 43.1104 52.5117 43.1104L44.4617 43.1129C43.4942 44.3879 42.3192 45.5129 40.9617 46.4379L27.5117 55.6104L14.0617 46.4404C12.043 45.064 10.3911 43.2153 9.24957 41.0551C8.10804 38.8949 7.51147 36.4886 7.51172 34.0454V13.6979C7.51202 13.1652 7.68244 12.6466 7.99812 12.2176C8.31381 11.7886 8.75827 11.4716 9.26672 11.3129L27.5117 5.61035ZM27.5117 10.8454L12.5117 15.5354V34.0454C12.5114 35.5759 12.8623 37.0861 13.5376 38.4597C14.2129 39.8332 15.1945 41.0334 16.4067 41.9678L16.8792 42.3079L27.5117 49.5579L36.9667 43.1104H25.0117C24.3487 43.1104 23.7128 42.847 23.244 42.3781C22.7751 41.9093 22.5117 41.2734 22.5117 40.6104V20.6104C22.5117 19.9473 22.7751 19.3114 23.244 18.8426C23.7128 18.3737 24.3487 18.1104 25.0117 18.1104H42.5117V15.5354L27.5117 10.8454ZM27.5117 30.6104V38.1104H50.0117V30.6104H27.5117ZM27.5117 25.6104H50.0117V23.1104H27.5117V25.6104Z"
        fill="#008AFF"
      />
    </svg>
  );
};
